import React from "react";
import Label from "../atoms/Label";

export default ({ title, label, paragraph, isCentred, wide}) =>
    <div className={ "m-section-headline" + (isCentred ? " u-center-text" : "") + " u-container" + ( wide ? "" : " u-container--medium" ) }>
        <Label text={ label }/>
        <h2 className="m-section-headline__title">{ title }</h2>
        <p>{ paragraph }</p>
    </div>;